import React from "react";
import ReactDOM from "react-dom";
import "@serendie/design-token/tokens.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./Common/LuxonExtensions";
import "./Common/ArrayExtensions";
import { createRoot } from 'react-dom/client';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);
root.render(<React.StrictMode>
    <App />
</React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
